__turbopack_context__.v({
  "dashboard": "dashboard-module__PPq9Qa__dashboard",
  "dashboardWrapper": "dashboard-module__PPq9Qa__dashboardWrapper",
  "hidden": "dashboard-module__PPq9Qa__hidden",
  "mainTitle": "dashboard-module__PPq9Qa__mainTitle",
  "page": "dashboard-module__PPq9Qa__page",
  "readingWrapper": "dashboard-module__PPq9Qa__readingWrapper" + " " + "dashboard-module__PPq9Qa__viewWrapper",
  "showView": "dashboard-module__PPq9Qa__showView",
  "sidebar": "dashboard-module__PPq9Qa__sidebar",
  "view": "dashboard-module__PPq9Qa__view" + " " + __turbopack_context__.i(50657)["animateMenu"],
  "viewWrapper": "dashboard-module__PPq9Qa__viewWrapper",
});
